import React, { useEffect, useState } from 'react'
import Scope1 from './scope1'
import Scope2 from './scope2'
import Scope3 from './scope3'
import Scope4 from './scope4'
import { HomeContextProvider } from '../context/homeContext'
import AIRecommend from './aiRecommend'
import { getJobRecommendAIStorage } from '../../../utils/localStorage'
import { useRecoilValue } from 'recoil'
import { isGetJobRecommendAIState } from '../../../recoil/states/default'

const ContentHome = () => {
    const [showJobRecommendAI, setShowJobRecommendAI] = useState(false)
    const isGetJobRecommendAI = useRecoilValue(isGetJobRecommendAIState)
    useEffect(() => {
        const data = getJobRecommendAIStorage()
        setShowJobRecommendAI(!!data)
    }, [isGetJobRecommendAI])

    return (
        <HomeContextProvider>
            <Scope1 />
            {showJobRecommendAI && <AIRecommend />}
            <Scope2 />
            <Scope3 />
            <Scope4 />
        </HomeContextProvider>
    )
}

export default ContentHome